import React, { useState } from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    FormControlLabel,
    Box,
    Switch,
    Typography,
    Paper,
    Grid,
    Button,
    Collapse,
    IconButton,
    SelectChangeEvent
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';

interface Props {
    handleFilter: (criteria: Partial<{
        year: string,
        reportFiled: boolean,
        isArchived: boolean,
        isLocal: boolean
    }>) => void;
}

const FilterLitigationDeadlines = (props: Props) => {
    const [year, setYear] = useState<string>('');
    const [reportFiled, setReportFiled] = useState<boolean>(false);
    const [isLocal, setIsLocal] = useState<boolean>(false);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [isFilterExpanded, setIsFilterExpanded] = useState<boolean>(false);

    const yearOptions = [
        { id: 2025, name: '2025' },
        { id: 2024, name: '2024' },
        { id: 2023, name: '2023' }
    ];

    const handleYearChange = (event: SelectChangeEvent<string>) => {
        setYear(event.target.value);
    };

    const handleReportFiledChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReportFiled(event.target.checked);
    };

    const handleLocalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsLocal(event.target.checked);
        props.handleFilter({ isLocal: event.target.checked });
    };

    const handleIsArchivedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsArchived(event.target.checked);
        props.handleFilter({ isArchived: event.target.checked });
    };

    const toggleFilterExpansion = () => {
        setIsFilterExpanded(!isFilterExpanded);
    };

    const handleClearFilters = () => {
        setYear('');
        setReportFiled(false);
        props.handleFilter({ year: '', reportFiled: false });
    };

    const handleApplyFilters = () => {
        const handleFilterParams = {
            year,
            reportFiled,
        };

        props.handleFilter(handleFilterParams);
    }

    return (
        <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f5f5f5' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6">Filters</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isLocal}
                                onChange={handleLocalFilterChange}
                                name="isLocal"
                            />
                        }
                        label='Local Filers?'
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isArchived}
                                onChange={handleIsArchivedChange}
                                name="isArchived"
                            />
                        }
                        label='Archived?'
                    />
                    <IconButton onClick={toggleFilterExpansion} color="primary" aria-label="toggle filters">
                        <FilterListIcon />
                    </IconButton>
                </Box>
            </Box>

            <Collapse in={isFilterExpanded}>
                <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormControl sx={{ width: '25%' }}>
                                <InputLabel>Year</InputLabel>
                                <Select
                                    name="year"
                                    value={year}
                                    onChange={handleYearChange}
                                    fullWidth
                                    label="Year"
                                    variant="outlined"
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {yearOptions.map((option) => (
                                        <MenuItem key={option.id} value={option.id.toString()}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={reportFiled}
                                        onChange={handleReportFiledChange}
                                        name="reportFiled"
                                    />
                                }
                                label="Report Filed?"
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button
                                variant="outlined"
                                startIcon={<ClearIcon />}
                                onClick={handleClearFilters}
                            >
                                Clear Filters
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleApplyFilters}>
                                Apply Filters
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Collapse>
        </Paper>
    );
};

export default FilterLitigationDeadlines;